import { ReactChildren } from '../../types/common'

export default function ProductCard({ children }: ReactChildren): JSX.Element {
  return (
    <div className="tw-border-2 tw-border-solid tw-border-system-grey-300 tw-rounded tw-p-3">
      <div className="tw-flex tw-items-center">{children}</div>
    </div>
  )
}
